import React, { FC } from "react";
import BlogNav from "./BlogNav";

export interface HeaderProps {
  className?: string;
}

const BlogHeader: FC<HeaderProps> = ({ className = "" }) => {
  const renderNav = () => {
    return <BlogNav />;
  };

  return (
    <div
      className={`nc-Header sticky top-0 w-full left-0 right-0 z-40 nc-header-bg ${className}`}
    >
      {renderNav()}
    </div>
  );
};

export default BlogHeader;
